import Listing from "./pages/listing"
import SearchProduct from './pages/search-product'
import UserAuth from "./pages/auth"
import AddEditProduct from "./pages/add-edit-product/"
import AddEditProductOmni from "./pages/omni-add-edit-product/"
import EnrichEditProduct from "./pages/enrich-product"
import EditBrandCategory from "./pages/edit-brand-category"
import UpdateProductWalkthrough from "./pages/update-product-walkthrough"
import AudiLogin from "./pages/auditor-login"
import AuditEnrichLogin from "./pages/audit-enrich-login"
import AuditEnrichHome from "./pages/audit-enrich-home"
import AuditEnrichProduct from './pages/audit-enrich-product'
import DashBoard from "./pages/dashboard"
import AuditHome from "./pages/audit-home"
import ContractList from "./pages/audit-home/contractList"
import AddEditItem from "./pages/add-edit-item"
import ContractorLogin from "./pages/contractor-login"
import ContractListing from "./pages/contractor-flow"
import ContractSearch from "./pages/contractor-flow/search-contracts"
import BulkUploadSlider from './pages/bulk-upload/'
import PhotoSlider, { JdPhotoSlider } from './pages/photo-slider'
import ProductInventory from "./pages/product-inventory"
import loadable from "@loadable/component"
import React from "react"
import DiscountList from "./pages/discount/discountList/index"
import OrderReturn from "./pages/order/order-return/index"
import OrderListing from "./pages/order/order-listing/index"
import AddEditDiscount from "./pages/discount/add-edit/index"
import CotractorHome from "./pages/contractor-home"
import ContractorMainV4 from "./pages/contractor-home/ContractorMainV4"
import DeliveryBoy from "./pages/deliveryboy/index"
import DeliveryTracking from "./pages/deliery-tracking/index"
import DeliveryCharge from "./pages/deliverycharge"
import OrderListingNew from "./pages/order_new/order-listing/index"
import ActionCardIndex from "./common/Listing/actionCardIndex"
import ObeLogin from "./pages/obe-login"
import FileUpload from "./pages/file-upload"

export default [{
	...Listing,
	exact: true,
	path: "/products"
},
{
	...Listing,
	exact: true,
	path: "/brochure"
},
{
	...SearchProduct,
	exact: true,
	path: "/search"
},
{
	...ActionCardIndex,
	exact: true,
	path: "/smartcard/:cardType"
},
{
	...Listing,
	exact: true,
	path: "/products/smartcard/:cardType"
}, 
{
	...AddEditProduct,
	exact: true,
	path: "/products/edit/:productId",
	isEditProduct: true,
	requireSession:true,
},
{
	...AddEditProduct,
	exact: true,
	path: "/products/add/:productId?",
	requireSession:true,
},
{
	...AudiLogin,
	exact: true,
	path: "/login",
	forceMobileView: true
}, {
	...AddEditProductOmni,
	exact: true,
	path: "/products/edit-omni/:productId",
	isEditProduct: true,
	requireSession:true,
}, {
	...AddEditProductOmni,
	exact: true,
	path: "/products/add-omni/:productId?",
	requireSession:true,
},{
	...EnrichEditProduct,
	exact: true,
	path: "/products/enrich/:productBankId?",
	forceMobileView: true
},{
	...{
		component: loadable(() => import(/* webpackChunkName: "homepage" */'./pages/add-edit-product/ItemSearchSlider'), {
			fallback: <div>Loading...</div>
		}),
	},
	exact: true,
	path: "/products/itemsearch",
	requireSession: true
}, {
	...UserAuth,
	exact: true,
	path: "/products/auth"
}, {
	...UserAuth,
	exact: true,
	path: "/products/login"
}, {
	...EditBrandCategory,
	exact: true,
	path: "/edit-category"
}, {
	...UpdateProductWalkthrough,
	exact: true,
	path: "/update-product-walkthrough"
}, {
	...EditBrandCategory,
	exact: true,
	path: "/edit-brand"
}, {
	...AuditEnrichLogin,
	exact: true,
	path: "/audit-enrich-login",
	forceMobileView: false
}, {
	...AuditEnrichHome,
	exact : true,
	path : "/audit-enrich-home"
}, {
	...AuditEnrichProduct,
	exact: true,
	path : "/products/editEnrich/:productId",
	isEditProduct: true

}, {
	...ObeLogin,
	exact: true,
	path: "/obe-login",
	forceMobileView: true
}, {
	...ObeLogin,
	exact: true,
	path: "/obe-login/:docId"
}, {
	...ContractorLogin,
	exact: true,
	path: "/contractor-login/:contractorVersion?",
	forceMobileView: true
}, {
	...ContractListing,
	exact: true,
	path: "/list-contracts/:contractorVersion?",
	forceMobileView: true
}, {
	...ContractSearch,
	exact: true,
	path: "/contractor-search/:contractorVersion?",
	forceMobileView: true
}, {
	...CotractorHome,
	exact: true,
	path: "/contractor-home",
	forceMobileView: true
}, {
	...DashBoard,
	exact: true,
	path: "/dashboard/:modelName",
	hasWebView: true
}, {
	...AuditHome,
	exact: true,
	path: "/audit-home",
	forceMobileView: true
}, {
	...ContractList,
	exact: true,
	path: "/audit-home/list",
	forceMobileView: true
}, {
	...AddEditItem,
	exact: true,
	path: "/add-item"
}, {
	...BulkUploadSlider,
	exact: true,
	path: "/vendor-bulk-import"
}, {
	...BulkUploadSlider, //#TO_DO combine both these routes later
	exact: true,
	path: "/bulk-upload/:type"
},  {
	...BulkUploadSlider, //#TO_DO combine both these routes later
	exact: true,
	path: "/bulk-upload",
	requireSession: true
},
{
	...AddEditItem,
	exact: true,
	path: "/edit-item/:itemId"
}, {
	...PhotoSlider,
	exact: true,
	path: "/products/photos"
}, {
	...JdPhotoSlider,
	exact: true,
	path: "/products/jd-photos",
}, {
	...ProductInventory,
	exact: true,
	path: '/products/inventory'	// will change later acc to story
},{
	...ProductInventory,
	exact: true,
	path: '/products/inventory/:tab'	// will change later acc to story
},{
	...DiscountList,
	exact: true,
	path: "/products/discount",
},
,{
	...AddEditDiscount,
	exact: true,
	path: "/products/discount/:add",
},
{
	...OrderReturn,
	exact: true,
	path: "/orders/return",
},
{
	...OrderReturn,
	exact: true,
	path: "/orders/return/:tab", //will change if their issue
},
{
	...OrderListingNew,
	exact: true,
	path: "/orders"
},{
	...OrderListingNew,
	exact: true,
	path: "/orders/:tab"
},{
	...DeliveryBoy,
	exact: true,
	path: "/deliveryboy"
},{
	...DeliveryTracking,
	exact: true,
	path: "/deliverytracking/:order_id"
},{
	...DeliveryCharge,
	exact: true,
	path: "/deliverycharge"
},
{
	...FileUpload,
	exact: true,
	path: "/file-upload",
	requireSession: true
}
// {
// 	...OrderListingNew,
// 	exact: true,
// 	path: "/orders-new"
// },{
// 	...OrderListingNew,
// 	exact: true,
// 	path: "/orders-new/:tab"
// }
];
